import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-align_centers_horizontal",
  "use": "icon-align_centers_horizontal-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-align_centers_horizontal\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<polygon points=\"19 11 19 8 13 8 13 5 12 5 12 8 6 8 6 11 12 11 12 13 9 13 9 16 12 16 12 19 13 19 13 16 16 16 16 13 13 13 13 11 19 11\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol